<template>
  <div class="html-embed">
    <div ref="source"></div>
  </div>
</template>

<script>
export default {
  name: "HtmlEmbed",
  props: {
    html: {
      default: null,
      type: String,
    },
  },
  mounted () {
    this.$refs.source.innerHTML = this.html;
    Array.from( this.$refs.source.querySelectorAll( "script" ) )
      .forEach( oldScript => {
        const newScript = document.createElement( "script" );

        Array.from( oldScript.attributes )
          .forEach( attr => newScript.setAttribute( attr.name, attr.value ) );

        newScript.appendChild( document.createTextNode( oldScript.innerHTML ) );
        oldScript.parentNode.replaceChild( newScript, oldScript );
      } );
  },

};
</script>

<style>

</style>
